import React, { useEffect, useState, useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { UserContext } from '../contexts/UserContext';
import Traductor from '../components/Traductor';
import AuctionsHome from '../components/auctions/AuctionsHome';
import Huerto from '../components/huerto/scoring/index';
import Modal from 'components/batches/Details/DetailsModal';

import '../css/modules/HomeModule.css';
import UserService from '../services/UserService';
import Globals from '../Globals';
import * as actions from '../redux/actions/batches';
import SellService from './../services/SellService';
import ParseService from '../services/ParseService';
import { withCookies } from 'react-cookie';

import usePermissions from 'hooks/usePermissions';
import { READONLY_PERMISSION } from 'constants/Permissions';

function HomeModule({ history, cookies }) {
    const { user, setCifs, setPreferences } = useContext(UserContext);

    const t = new Traductor();
    const { checkPermission } = usePermissions();
    const [tabAuctions, setTabAuctions] = useState(null);
    const [aviso, setAviso] = useState(true);

    const LoadPreferences = useCallback(async () => {
        if (!cookies.get(Globals.COOKIES.JWT)?.AccessToken) return;

        const readOnly = user.data.Permissions?.some(
            ({ NombreConstante }) => NombreConstante === READONLY_PERMISSION
        );
        if (readOnly) return;

        var preferencesResponse = await new UserService().getPreferences(
            cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (preferencesResponse) {
            var preferences = JSON.parse(preferencesResponse.Result);
            if (user.data.Empleado !== undefined) {
                let cifsResponse = await new SellService().getBuyers(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    user.data.Empleado.Id
                );
                if (cifsResponse && cifsResponse.Result) {
                    var cifs = new ParseService().Parse(cifsResponse.Result);
                    setCifs(cifs);
                    if (
                        preferences &&
                        preferences.PreferenceId === 0 &&
                        cifs.length === 1
                    ) {
                        preferences.CifBuyer = cifs[0].CIF;
                        preferences.ClientId = cifs[0].Id;
                    }
                }
            }
            setPreferences(preferences);
        }
    }, [cookies, setCifs, setPreferences, user.data.Empleado]);

    useEffect(() => {
        LoadPreferences();
        window.bronson.$$('#auctions-tabs').component('tabs');
    }, [LoadPreferences]);

    useEffect(() => {
        if (history)
            if (history.location.state != null)
                if (history.location.state.view === '/huerto') {
                    try {
                        document
                            .getElementById('huertoHome')
                            .click(
                                document.getElementById('huertoHome'),
                                'huerto'
                            );
                    } catch {}
                    setTabAuctions(false);
                    return;
                }
        if (checkPermission('CNST_GESTION_COMERCIAL_CONCESIONARIO')) {
            setTabAuctions(true);
        } else if (
            checkPermission('CNST_REMAMOBILE_VER_VENCIMIENTO_CONCESIONARIO')
        ) {
            setTabAuctions(false);
        }
    }, [checkPermission, history, user.data.Permissions]);

    const clickbuttontab = async (element, code) => {
        let elements = document.getElementsByClassName('js-slider__element');
        if (elements.length > 1) {
            let viewport1 = elements[0].getElementsByClassName(
                'flickity-viewport'
            )[0];
            let viewport2 = elements[1].getElementsByClassName(
                'flickity-viewport'
            )[0];
            let value = viewport1.style.getPropertyValue('height');
            if (value == '0px')
                value = viewport2.style.getPropertyValue('height');
            viewport1.style.height = value;
            viewport2.style.height = value;
        }
        if (code == 'auctions') setTabAuctions(true);
        else setTabAuctions(false);
    };

    const printAuctionsHome = () => {
        if (!tabAuctions || tabAuctions == null) return null;
        return <AuctionsHome history={history}></AuctionsHome>;
    };

    const printHuertoHome = () => {
        if (tabAuctions || tabAuctions == null) {
            if (history != undefined)
                if (history.location.state != null)
                    if (history.location.state.matrixContracts != null)
                        return <Huerto> </Huerto>;
            return null;
        }
        return <Huerto> </Huerto>;
    };

    return (
        <section className="o-content-section">
            <div className="o-layout">
            <div className="o-layout__item  u-1/6">
            </div>    
            <div className="o-layout__item  u-4/6">
            {aviso && (
                
                <div className="c-notification__container  js-notification-container">
                       <div className="c-notification  c-notification--warning">
                           <div className="c-notification__outer-wrap">
                               <div className="c-notification__inner-wrap">
               
                                   <i className="c-notification__status-icon" aria-hidden="true" role="img"></i>
               
                                   <div className="c-notification__content">
                                       <h3 className="c-notification__title">¡¡ATENCIÓN!!</h3>
               
                                       <p className="c-notification__text">
                                       Hemos detectado que se están enviando correos desde dominios no correspondientes a VWFS con identidades suplantadas de personal de nuestra compañía, informando de adjudicaciones de vehículos reales, pero mostrando una cuenta corriente de pago que no se corresponde con la codificación de Volkswagen Bank (código entidad 1480). Es muy importante que confirméis que el correo de adjudicación que recibís corresponde a una cuenta genérica perteneciente a VWFS (dominio vwfs.com al final de la cuenta de correo), ya que no se utilizan cuentas personales en la comunicación de las adjudicaciones, y que la cuenta de pago para la compra de los vehículos es una cuenta domiciliada en Volkswagen Bank, ya que todos los cobros de Remarketing los centralizamos en este banco.
                                       </p>
                                   </div>
               
                                   <button type="button" title="CLOSE" className="js-notification-close  c-notification__close"
                                   onClick={() =>
                                       setAviso(false)
                                   }
                                   >                        
                                   </button>
               
                               </div>
                           </div>
                       </div><hr></hr>
                </div>)}
            </div>
            <div className="o-layout__item  u-1/6">
            </div> 
            </div>
            <div id="Home" className="o-page-wrap o-page-wrap--xsmall">
                {user.logged && (
                    <div id="auctions-tabs" className="c-tabs js-tabs">
                        <nav
                            className={
                                checkPermission(
                                    'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                                ) &&
                                checkPermission(
                                    'CNST_REMAMOBILE_VER_VENCIMIENTO_CONCESIONARIO'
                                )
                                    ? ''
                                    : 'u-hide'
                            }
                        >
                            <ul className="c-tabs__nav  js-tabs__nav">
                                {checkPermission(
                                    'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                                ) ? (
                                    <li className="c-tabs__nav-item">
                                        <button
                                            className="c-tabs__nav-link  js-tabs__nav-link"
                                            onClick={() =>
                                                clickbuttontab(this, 'auctions')
                                            }
                                        >
                                            <span className="c-tabs__text">
                                                {t.getTraduction('Subastas')}
                                            </span>
                                        </button>
                                    </li>
                                ) : null}
                                {checkPermission(
                                    'CNST_REMAMOBILE_VER_VENCIMIENTO_CONCESIONARIO'
                                ) ? (
                                    <li
                                        className="c-tabs__nav-item"
                                        id="btn_go_to_huerto"
                                    >
                                        <button
                                            className="c-tabs__nav-link  js-tabs__nav-link"
                                            id="huertoHome"
                                            onClickCapture={() =>
                                                clickbuttontab(this, 'huerto')
                                            }
                                        >
                                            <span className="c-tabs__text">
                                                {t.getTraduction('Huerto')}
                                            </span>
                                        </button>
                                    </li>
                                ) : null}
                            </ul>
                        </nav>
                        <div>
                            {checkPermission(
                                'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                            ) ? (
                                <div className="c-tabs__content rema-c-tabs__content js-tabs__content">
                                    {printAuctionsHome()}
                                </div>
                            ) : null}
                            {checkPermission(
                                'CNST_REMAMOBILE_VER_VENCIMIENTO_CONCESIONARIO'
                            ) ? (
                                <div className="c-tabs__content rema-c-tabs__content js-tabs__content">
                                    {printHuertoHome()}
                                </div>
                            ) : null}
                        </div>
                        <Modal
                            visible={
                                !checkPermission(
                                    'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                                ) &&
                                !checkPermission(
                                    'CNST_REMAMOBILE_VER_VENCIMIENTO_CONCESIONARIO'
                                )
                            }
                            title={t.getTraduction('PermissionsErrorTitle')}
                            content={t.getTraduction('PermissionsErrorBody')}
                        />
                    </div>
                )}
            </div>
        </section>
    );
}

const mapStateToProps = state => ({
    vehiclesInTrolley: state.carsBatch.cars,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(actions, dispatch),
});

export default withCookies(
    connect(mapStateToProps, mapDispatchToProps)(HomeModule)
);
